import React from "react";
import { MapPin, Mail, Phone } from "lucide-react";
import "../styles/Contact.css";

const ContactUs = () => {
  return (
    <div className="contact-section" id="ContactUs">
      <h1 className="contactus-title">CONTACT US</h1>
      <p className="contactus-subtitle">
        We align leaders around a shared purpose and strategic story that
        catalyzes their business and brand to take action.
      </p>

      <div className="contactus-map-wrapper">
        <div className="contactus-card">
          <div className="contactus-info">
            <div className="contactus-icon">
              <MapPin />
            </div>
            <h3>Address:</h3>
            <p>
              3-601/2 First Floor, Pedda Golconda,
              <br />
              Shamshabad, Hyderabad, India – 501218
            </p>
          </div>

          <div className="contactus-info">
            <div className="contactus-icon">
              <Mail />
            </div>
            <h3>Email:</h3>
            <p>
              <a href="mailto:info@parwahindustries.com">
                info@parwahindustries.com
              </a>
              <br />
            </p>
          </div>

          <div className="contactus-info">
            <div className="contactus-icon">
              <Phone />
            </div>
            <h3>Call us:</h3>
            <p>+91 7207149900</p>
          </div>
        </div>
      </div>

      <div className="contactus-map-fixed">
        <iframe
          title="Google Maps"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3794.794840096275!2d78.39480697593367!3d17.19886598332748!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbf912ca57fc27%3A0xb397af2e4f6053a1!2sParwah%20Industries!5e0!3m2!1sen!2sin!4v1718604625883!5m2!1sen!2sin"
          width="600"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
};

export default ContactUs;
